// extracted by mini-css-extract-plugin
export var carrierTab = "_6b-0";
export var carrierTabActive = "_6b-1 _6b-0";
export var carrierTabInactive = "_6b-2 _6b-0";
export var carrierTabLabel = "_6b-3";
export var carrierTabLabelActive = "_6b-4 _6b-3";
export var carrierTabLabelInactive = "_6b-5 _6b-3";
export var carrierTabPercentage = "_6b-6";
export var carrierTabPercentageActive = "_6b-7 _6b-6";
export var carrierTabPercentageInactive = "_6b-8 _6b-6";
export var carrierTabWinnable = "_6b-9";
export var carrierTabWinnableActive = "_6b-a _6b-9";
export var carrierTabWinnableInactive = "_6b-b _6b-9";
export var comparisonContainer = "_6b-d";
export var missingRateButton = "_6b-n";
export var missingRateButtonActive = "_6b-o _6b-n";
export var missingRateButtonInactive = "_6b-p _6b-n";
export var missingRateButtonLabel = "_6b-q";
export var missingRateButtonLabelActive = "_6b-r _6b-q";
export var missingRateButtonLabelInactive = "_6b-s _6b-q";
export var sidebar = "_6b-c";
export var strategyButton = "_6b-e";
export var strategyButtonActive = "_6b-f _6b-e";
export var strategyButtonDescription = "_6b-k";
export var strategyButtonDescriptionActive = "_6b-l _6b-k";
export var strategyButtonDescriptionInactive = "_6b-m _6b-k";
export var strategyButtonInactive = "_6b-g _6b-e";
export var strategyButtonLabel = "_6b-h";
export var strategyButtonLabelActive = "_6b-i _6b-h";
export var strategyButtonLabelInactive = "_6b-j _6b-h";
export var unitToggleButton = "_6b-t";
export var unitToggleButtonActive = "_6b-u _6b-t";
export var unitToggleButtonInactive = "_6b-v _6b-t";
export var unitToggleButtonLabel = "_6b-w";
export var unitToggleButtonLabelActive = "_6b-x _6b-w";
export var unitToggleButtonLabelInactive = "_6b-y _6b-w";